module.exports = __webpack_public_path__ + "img/minor_n6c3yd.b88c1993.svg";